const PageTitle = ({ children, left }) => (
  <h2 className={`w-full ${!left && "text-center"} mt-2`}>{children}</h2>
);

export default PageTitle;
